export abstract class AbstractClass {
  // Abstract Properties
  public abstract modelName: string;
  public abstract modelCells: ModelCell[];
  public abstract tabs: TabCells[];
  public abstract tableCells: TableCell[];
  public abstract idName: string;
  public abstract langBase: string;
  public abstract model: any;
  public abstract formCells: FormCell[];
  public modelList: any[] = [];
  public stringsToRemove: string[] = [];
  public fieldsUnrequiredUpdate: string[] = [];
  public jsonBase = {};
  private errors: string[] = [];

  constructor() {
  }

  set(model: any) {
    const a = this.model;
    Object.entries(this.model).forEach(
      key => {
        switch (Object.prototype.toString.call(key[1])) {
          case '[object Date]':
            const tempDate = new Date(model[key[0]]);
            const tempText = tempDate.getFullYear() + '-'
              + (tempDate.getMonth() < 10 ? '0' : '') + (tempDate.getMonth() + 1) + '-'
              + (tempDate.getDate() < 10 ? '0' : '') + tempDate.getDate() + ' '
              + (tempDate.getHours() < 10 ? '0' : '') + tempDate.getHours() + ':'
              + (tempDate.getMinutes() < 10 ? '0' : '') + tempDate.getMinutes() + ':'
              + (tempDate.getSeconds() < 10 ? '0' : '') + tempDate.getSeconds();
            this.model[key[0]] = tempText;
            break;
          case '[object Object]':
            if (key[0] === 'image') {
              this.model[key[0]] = null;
            } else {
              this.model[key[0]] = model[key[0]];
            }
            break;
          default:
            /*console.log("this model", this.model);
            console.log("key", key);
            console.log("model", model);*/
            if (key[0] === 'latitude') {
              this.model['latitude'] = model[key[0]];
            } else if (key[0] === 'longitude') {
              this.model['longitude'] = model[key[0]];
            } else {
              this.model[key[0]] = model[key[0]];
            }

            // console.log("model lat", this.model['latitude']);
            // console.log("model lng", this.model['longitude']);
            break;
        }
      }
    );
    /* console.log("model lat Final", this.model['latitude']);
    console.log("model lng Final", this.model['longitude']);
    console.log("SETMODEL", this.model); */
  }

  public getJsonBase = () => {
    const arrStrings = [this.idName, 'createdAt', 'updatedAt', 'photo']; // 'createdBy'
    this.stringsToRemove.map(s => {
      arrStrings.push(s);
    });
    this.jsonBase = {};
    Object.entries(this.model).forEach(
      key => {
        console.log(Object.prototype.toString.call(key[1]));
        switch (Object.prototype.toString.call(key[1])) {
          case 'photo':
            if (arrStrings.indexOf(key[0]) === -1 && this.model[key[0]] != "") {
              // @ts-ignore
              this.jsonBase[key[0]] = this.model[key[0]];
            }
            break;
          default:
            if (arrStrings.indexOf(key[0]) === -1) {
              // @ts-ignore
              if (this.model[key[0]] !== null) {
                // @ts-ignore
                this.jsonBase[key[0]] = this.model[key[0]];
              }
            }
            break;
        }
      }
    );
    return this.jsonBase;
  }

  public getJsonUpdate = () => {
    const arrStrings = ['createdAt', 'updatedAt'];
    /* this.stringsToRemove.map(s => {
      arrStrings.push(s);
    }); */
    this.jsonBase = {};
    Object.entries(this.model).forEach(
      key => {
        if (arrStrings.indexOf(key[0]) === -1) {
          switch (Object.prototype.toString.call(key[1])) {
            default:
              // @ts-ignore
              if (this.model[key[0]] !== null) {
                // @ts-ignore
                this.jsonBase[key[0]] = this.model[key[0]];
              }
              break;
          }
        }
      }
    );
    return this.jsonBase;
  }

  public getInputsTab = (id: number): ModelCell[] => {
    return this.tabs[id].cells;
  }
  public getTabs = (): TabCells[] => {
    return this.tabs;
  }
  public getTableCells = (): TableCell[] => this.tableCells;

  public getInputsForm = (): FormCell[] => this.formCells.sort((a, b) => a.order - b.order );

  public getDownloadTitles = (): TableCell[] => this.tableCells.filter(t => t.download);

  public getInputsErrors = (): boolean => {
    let error = false;
    this.errors = [];
    this.getInputsForm().filter((i: FormCell) => i.required).map((value: FormCell, id: number) => {
      if (value.type === 'number') {
        if (this.model[value.name] === undefined || this.model[value.name] === null
          || this.model[value.name] === 0) {
          error = true;
          this.errors.push(value.label);
        }
      } else if (value.type === 'date') {
        if (this.model[value.name] === undefined || this.model[value.name] === null) {
          error = true;
          this.errors.push(value.label);
        }
      } else if (value.type === 'dateTime') {
        if (this.model[value.name] === undefined || this.model[value.name] === null) {
          error = true;
          this.errors.push(value.label);
        }
      } else if (value.type === 'boolean') {
        if (this.model[value.name] === undefined || this.model[value.name] === null) {
          error = true;
          this.errors.push(value.label);
        }
      } else {
        if (this.model[value.name] === undefined || this.model[value.name] === null
          || this.model[value.name] === '' || this.model[value.name].length === 0) {
          error = true;
          this.errors.push(value.label);
        }
      }
    });
    return error;
  }

  public getErrors = (): string[] => {
    return this.errors;
  }
}

export interface ModelCell {
  name: string;
  label: string;
  cellType: string;
  disable: boolean;
  cols: string;
  order: number;
  required: boolean;
}

export interface TabCells {
  name: string;
  order: number;
  cells: ModelCell[];
}

export interface TableCell {
  name: string;
  label: string;
  cellType: string;
  order: boolean;
  download: boolean;
}

export interface FormCell {
  name: string;
  label: string;
  cellType: string;
  disable: boolean;
  cols: string;
  order: number;
  required: boolean;
  multiple: boolean;
  type: string;
}
